import React, { useEffect, useState } from "react";
import LOGO from "../Assets/delhiBackground.png";
import { useSelector, useDispatch } from "react-redux";
import land from "../Assets/land.png";
import basket from "../Assets/basketball-player.png";
import law from "../Assets/law.png";
import search from "../Assets/search.png";
import sky from "../Assets/skyscraper.png";
import vegan from "../Assets/vegan.png";
import list from "../Assets/list.png";
import Table from "react-bootstrap/Table";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import SideNavbar from "./SideNavBar";
import SideBar from "./SideBar";
import { citizenDashboardDetails } from "../Services/getServices";
import { citizenSchemeDetails } from "../Services/getServices";
import { loader } from "../redux/type";
import { Link } from "react-router-dom";

import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CitizenSchemeDetails = () => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const dispatch = useDispatch();
  const [deptList, setDeptList] = useState([]);
  const userData = JSON.parse(localStorage.getItem("user"));
  console.log("DATATATA=", userData?.user?.mobile);
  const [bhoomiDetails, setBhoomiDetails] = useState([]);
  const token = localStorage.getItem("token");
  useEffect(() => {
    dashboardDetails();
    schemeDetails();
  }, []);

  function schemeDetails() {
    console.log("DEKHO");
    let mob = 9811090749;
    dispatch({ type: loader.startLoader });

    citizenSchemeDetails(mob, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        // console("FIRST")
        console.log("SCHEME=", res?.data?.result?.bhoomiDashboardDetails);

        setBhoomiDetails(res?.data?.result?.bhoomiDashboardDetails);
      } else {
        console.log(res);
      }
    });
  }

  function dashboardDetails() {
    dispatch({ type: loader.startLoader });

    citizenDashboardDetails((res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        // console.log(res);
        setDeptList(res?.data?.result?.deptApplicationList);
      } else {
        // console.log(res);
      }
    });
  }
  var [arr, setArr] = useState([]);
  const [appDetails, setAppDetails] = useState("0");
  const [deptHeader, setDeptHeader] = useState("");
  const [activeCard, setActiveCard] = useState(null);
  function applicationInfo(ind) {
    setAppDetails("2");
    console.log("INDEX=", ind);
    setDeptHeader(deptList[ind]?.departmentName);
    console.log("DATA=", deptList[ind]?.application);
    // deptList[ind].application;
    // let arr=deptList[ind]?.application;
    setArr(deptList[ind]?.application);
    setActiveCard(ind);
  }

  return (
    <>
      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h5 className="h2_heading">DDA Departments</h5>

          {/* <div>
   
      <Slider {...settings}>
        <div>
          <h3>Container 1</h3>
        </div>
        <div>
          <h3>Container 2</h3>
        </div>
        <div>
          <h3>Container 3</h3>
        </div>
        <div>
          <h3>Container 4</h3>
        </div>
        <div>
          <h3>Container 5</h3>
        </div>
      </Slider>
    </div> */}

          <div className="row forSpace">
            <Slider {...settings}>
              {deptList?.map((val, index) => (
                <div
                  key={index}
                  className="card marTop shadow cardDash "
                  onClick={() => {
                    applicationInfo(index);
                  }}
                >
                  <div
                    className="card-body"
                    style={{
                      background: activeCard === index ? "#e7f1ff" : "white",
                    }}
                  >
                    <div className="row">
                      <div className="row">
                        <img
                          src={"http://4.224.85.195" + val.application[0].icon}
                          className="iconSize"
                          alt="delhi"
                        />
                      </div>
                      <div className="row">
                        <h5>{val.departmentName}</h5>
                        <p className="fontSize">{val.deptDis}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>

            {appDetails === "2" ? (
              <>
                <div className="row marTop">
                  <h5>{deptHeader} Application</h5>

                  {arr?.map((va, i) => (
                    <>
                      <div key={i} className="row marTop">
                        <div className="col-12 card shadow">
                          <div className="card-body">
                            <div className="sameLine2">
                              <img
                                src={"http://4.224.85.195" + va?.icon}
                                className="iconSize2 "
                                alt="delhi"
                              />
                            </div>

                            <div className="sameLine2">
                              <h5>{va?.applicationName}</h5>
                              <p style={{ fontSize: "10px" }}>
                                {va?.description}
                              </p>
                            </div>
                            <div
                              className="sameLine2"
                              style={{ float: "right" }}
                            >
                              {/* <a
                                href={va?.url}
                                target="_blank"
                                alt="Link Not working"
                              > */}{" "}
                              {(va?.domainCode === "CS" || va?.domainCode==="MS" )? (
                                <>
                                  <a
                                    href={`${va?.url}?token=${token}`}
                                    target="_blank"
                                    alt="Link Not working"
                                  >
                                    <button className="btn btn-primary">
                                      Open
                                    </button>
                                  </a>
                                </>
                              ) : (
                                <>
                                  <Link
                                    to={"/" + va?.domainCode}
                                    state={{
                                      url_Link: va?.url,
                                      doCode: va?.domainCode,
                                    }}
                                  >
                                    <button className="btn btn-primary">
                                      Open
                                    </button>
                                  </Link>
                                </>
                              )}
                              {/* <Link
                                  to={"/" + va?.domainCode}
                                  state={{
                                    url_Link: va?.url,
                                    doCode: va?.domainCode,
                                  }}
                                >
                                  <button className="btn btn-primary">
                                    Open
                                  </button>
                                </Link> */}
                              {/* </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default CitizenSchemeDetails;
